Oskari.bundle_manager.registerDynamic('admin-users', function() {return import(/* webpackChunkName: "chunk_admin-users" */ 'oskari-loader!oskari-frontend/packages/framework/bundle/admin-users/bundle.js');});
